import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { ProductInfo } from '@ktypes/models';

@Component({
  selector: 'kui-app-switcher',
  templateUrl: './app-switcher.component.html',
  styleUrls: ['./app-switcher.component.scss'],
})
export class AppSwitcherComponent {
  @Input() apps: ProductInfo[];
  @Output() appClicked = new EventEmitter<ProductInfo>();

  open = false;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this._eRef.nativeElement.contains(event.target)) {
      this.open = false;
    }
  }

  constructor(private _eRef: ElementRef) {}

  onAppClick(app: ProductInfo) {
    this.open = false;
    this.appClicked.emit(app);
  }
}
